// src/Layout/Sidebar/index.jsx

import React, { Fragment, useState, useEffect, useContext } from "react";

import CustomContext from "../../_helper/Customizer";

import { MENUITEMS } from "./Menu";
import { ROLE_PERMISSIONS } from "./permissions";

import SidebarIcon from "./SidebarIcon";
import SidebarLogo from "./SidebarLogo";
import SidebarMenu from "./SidebarMenu";

const Sidebar = (props) => {
  const customizer = useContext(CustomContext);

  const { toggleIcon } = useContext(CustomContext);

  const id = window.location.pathname.split("/").pop();

  const defaultLayout = Object.keys(customizer.layout);

  const layout = id ? id : defaultLayout;

  // =====================================
  // ROLE
  // =====================================

  const role = JSON.parse(localStorage.getItem("authUser"))?.role || "USER";

  // =====================================
  // CHECK PERMISSION
  // =====================================

  const hasPermission = (permission) => {
    return ROLE_PERMISSIONS[role]?.includes(permission);
  };

  // =====================================
  // FILTER MENU
  // =====================================

  const filteredMenu = MENUITEMS.map((section) => {
    const filteredItems = section.Items.filter((item) => {
      // SUB MENU
      if (item.children) {
        const filteredChildren = item.children.filter((child) =>
          hasPermission(child.permission),
        );

        item.children = filteredChildren;

        return filteredChildren.length > 0;
      }

      // NORMAL LINK
      return hasPermission(item.permission);
    });

    return {
      ...section,
      Items: filteredItems,
    };
  }).filter((section) => section.Items.length > 0);

  // =====================================
  // STATE
  // =====================================

  const [mainmenu, setMainMenu] = useState(filteredMenu);

  const [width, setWidth] = useState(0);

  // =====================================
  // SCROLL
  // =====================================

  const handleScroll = () => {
    if (window.scrollY > 400) {
      document.querySelector(".sidebar-main").className =
        "sidebar-main hovered";
    } else {
      if (document.getElementById("sidebar-main")) {
        document.querySelector(".sidebar-main").className = "sidebar-main";
      }
    }
  };

  // =====================================
  // EFFECT
  // =====================================

  useEffect(() => {
    document.querySelector(".left-arrow")?.classList.add("d-none");

    window.addEventListener("resize", handleResize);

    handleResize();

    const currentUrl = window.location.pathname;

    filteredMenu.map((items) => {
      items.Items.filter((Items) => {
        if (Items.path === currentUrl) setNavActive(Items);

        if (!Items.children) return false;

        Items.children.filter((subItems) => {
          if (subItems.path === currentUrl) setNavActive(subItems);

          return subItems;
        });

        return Items;
      });

      return items;
    });

    window.addEventListener("scroll", handleScroll);

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);

      window.removeEventListener("resize", handleResize);
    };
  }, [layout]);

  // =====================================
  // RESIZE
  // =====================================

  const handleResize = () => {
    setWidth(window.innerWidth - 500);
  };

  // =====================================
  // ACTIVE CLASS
  // =====================================

  const activeClass = () => {
    document.querySelector(".bg-overlay1")?.classList.add("active");
  };

  // =====================================
  // NAV ACTIVE
  // =====================================

  const setNavActive = (item) => {
    mainmenu.map((menuItems) => {
      menuItems.Items.filter((Items) => {
        if (Items !== item) {
          Items.active = false;

          document.querySelector(".bg-overlay1")?.classList.remove("active");
        }

        if (Items.children && Items.children.includes(item)) {
          Items.active = true;

          document.querySelector(".sidebar-links")?.classList.add("active");
        }

        if (Items.children) {
          Items.children.filter((submenuItems) => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              Items.active = true;

              submenuItems.active = true;

              return true;
            } else {
              return false;
            }
          });
        }

        return Items;
      });

      return menuItems;
    });

    item.active = !item.active;

    setMainMenu([...mainmenu]);
  };

  // =====================================
  // CLOSE OVERLAY
  // =====================================

  const closeOverlay = () => {
    document.querySelector(".bg-overlay1")?.classList.remove("active");

    document.querySelector(".sidebar-links")?.classList.remove("active");
  };

  // =====================================
  // RENDER
  // =====================================

  return (
    <Fragment>
      <div
        className="bg-overlay1"
        onClick={() => {
          closeOverlay();
        }}
      ></div>

      <div
        className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`}
        sidebar-layout="stroke-svg"
      >
        <SidebarIcon />

        <SidebarLogo />

        <SidebarMenu
          menu={mainmenu}
          setMainMenu={setMainMenu}
          props={props}
          setNavActive={setNavActive}
          activeClass={activeClass}
          width={width}
        />
      </div>
    </Fragment>
  );
};

export default Sidebar;
